import React from "react";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const cards = [1, 2, 3];

const eventtitle = ["PyStart", "ML March", "AlgoExpert"];

const Description = [];

const Images = [
  "https://i.pinimg.com/originals/a2/6c/4b/a26c4b485716a585073da2af4328a8cd.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwNufTd72akt3Ffc6-RYGyEkZrV3IF7IJGwQ&usqp=CAU",
  "https://online.stanford.edu/sites/default/files/styles/figure_default/public/2018-03/engineering-computer-science-algorithms-design-analysis_soe-ycsalgorithms.png?itok=ZNj7f4u4",
];

const cardsData = [
  {
    title: "Pystart",
    description:
      "A 3 days Python bootcamp from scratch we will end with a hands on mini project",
    image:
      "https://i.pinimg.com/originals/a2/6c/4b/a26c4b485716a585073da2af4328a8cd.jpg",
    learnmore: "",
    register: "",
  },
  {
    title: "ML March",
    description:
      "In ML March we will do an hands on end to end machine learning project ",
    image: "https://miro.medium.com/max/1400/1*cG6U1qstYDijh9bPL42e-Q.jpeg",
    learnmore: "",
    register: "",
  },
  {
    title: "Algoexpert",
    description: "Simply a DSA  Hackathon",
    image: "https://i.ytimg.com/vi/kM9ASKAni_s/maxresdefault.jpg",
    learnmore: "",
    register: "",
  },
];


const theme = createTheme();

function Firstcomponentcards() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main>
        <Container sx={{ py: 2 }} maxWidth="md">
          <Grid container spacing={3}>
            {cardsData.map((card) => (
              <Grid item key={card} xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: "345",
                  }}
                >
                  <CardMedia
                    component="img"
                    height="140"
                    image={card.image}
                    alt="random"
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {card.title}
                    </Typography>
                    <Typography>
                      {card.description}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" to={card.register}>Register</Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </main>
    </ThemeProvider>
  );
}

export default Firstcomponentcards;
